angular.module('b2cApp.services').factory('ProjectReview',
    ['$resource',
        function ($resource) {
            return $resource('review');
        }
    ]
);
